<template>
  <div class="p-1">
    <customer-greeting :name="firstName"/>
    <next-steps />
    <share-address/>
    <manage-request />
    <pro-licensing />
  </div>
</template>

<script>
import workOrder from '@/mixins/work-order';

import CustomerGreeting from '../../components/CustomerGreeting';
import NextSteps from '../../components/NextSteps';
import ManageRequest from '../../components/ManageRequest';
import ProLicensing from '../../components/ProLicensing';
import ShareAddress from '../../components/ShareAddress';

export default {
  name: 'confirmation',
  components: {
    CustomerGreeting,
    NextSteps,
    ManageRequest,
    ProLicensing,
    ShareAddress,
  },
  mixins: [
    workOrder,
  ],
  data () {
    return {
      firstName: '',
    };
  },
  computed: {
    // Used by workOrder mixin
    jobId () {
      return this.$route.params.leadId;
    },
  },
  async mounted () {
    try {
      if (this.$route.params.leadId) {
        await this.fetchWorkOrder({ jobId: this.$route.params.leadId });

        this.firstName = this.workOrder.user.first_name;
      }
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  },
};
</script>
